/**
 * LINVÉ SKU Search Utility
 * Fetches and caches /collections/all?view=sku-index in sessionStorage.
 * Provides SKU matching logic identical to the live site.
 */
(function() {
  'use strict';

  function cleanSku(str) {
    return (str || '').toLowerCase().replace(/[\s\-_]/g, '');
  }

  function matchSkuProduct(product, rawQuery) {
    if (!product || !rawQuery) return null;
    const query = String(rawQuery).toLowerCase().trim();
    if (!query) return null;
    const queryClean = cleanSku(query);
    if (!queryClean) return null;

    // 1. Check handle
    const handle = (product.handle || '').toLowerCase();
    const handleClean = cleanSku(handle);
    if (handle.includes(query) || handleClean.includes(queryClean)) {
      return (product.skus && product.skus[0]) || product.handle.toUpperCase();
    }
    if (queryClean.length >= 4 && queryClean.includes(handleClean)) {
      return (product.skus && product.skus[0]) || product.handle.toUpperCase();
    }

    // 2. Check variant SKUs
    const skus = Array.isArray(product.skus) ? product.skus : [];
    for (let i = 0; i < skus.length; i++) {
      const sku = String(skus[i] || '').trim();
      if (!sku) continue;
      const skuDown = sku.toLowerCase();
      const skuClean = cleanSku(sku);
      if (skuDown.includes(query) || skuClean.includes(queryClean)) {
        return sku;
      }
      if (queryClean.length >= 4 && queryClean.includes(skuClean)) {
        return sku;
      }
    }

    return null;
  }

  let _skuIndexPromise = null;

  async function getSkuIndex() {
    try {
      const cached = sessionStorage.getItem('linve_sku_index');
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      }
    } catch (e) {}

    if (!_skuIndexPromise) {
      _skuIndexPromise = fetch('/collections/all?view=sku-index')
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(text) {
          var data = null;
          try {
            data = JSON.parse(text);
          } catch (e) {
            var match = text.match(/\[[\s\S]*\]/);
            if (match) {
              try { data = JSON.parse(match[0]); } catch (err) {}
            }
          }
          if (Array.isArray(data)) {
            try {
              sessionStorage.setItem('linve_sku_index', JSON.stringify(data));
            } catch (err) {}
            return data;
          }
          return [];
        })
        .catch(function(err) {
          console.warn('LINVÉ SKU index load error:', err);
          return [];
        });
    }

    return _skuIndexPromise;
  }

  window.LinveSkuSearch = {
    cleanSku: cleanSku,
    matchSkuProduct: matchSkuProduct,
    getSkuIndex: getSkuIndex
  };
})();
